(() => {
  // ===== Instellingen =====
  const DURATION_SEC = 10 * 60; // 10 minuten (pas aan)
  const STORAGE_KEY  = 'ampSlidecartCountdownEndsAt';

  // ===== Helpers =====
  function getEndTime() {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    const now = Date.now();
    if (saved && +saved > now) return +saved;
    const endsAt = now + DURATION_SEC * 1000;
    sessionStorage.setItem(STORAGE_KEY, String(endsAt));
    return endsAt;
  }
  function fmt(ms) {
    const s = Math.max(0, Math.floor(ms / 1000));
    const m = String(Math.floor(s / 60)).padStart(2, '0');
    const r = String(s % 60).padStart(2, '0');
    return `${m}:${r}`;
  }

  // Balk zo hoog mogelijk zetten
  function mountAtTop() {
    const bar = document.getElementById('cart-countdown');
    if (!bar) return false;
    const root = document.querySelector('#amp-slide-cart, .amp-slide-cart, [data-app="amp-slide-cart"], .slide-cart-drawer, cart-drawer, [data-cart-drawer]');
    if (root && root.firstElementChild !== bar) root.prepend(bar);
    bar.hidden = false;
    return true;
  }

  // Start timer (één interval tegelijk)
  function startTimer() {
    const wrap = document.getElementById('cart-countdown');
    const timerEl = document.getElementById('cart-timer');
    if (!wrap || !timerEl) return;

    mountAtTop();

    if (window._ampCartTimer) clearInterval(window._ampCartTimer);
    let endsAt = getEndTime();

    function tick() {
      const left = endsAt - Date.now();
      if (left <= 0) {
        clearInterval(window._ampCartTimer);
        timerEl.textContent = '00:00';
        wrap.setAttribute('data-expired','true');
        return;
      }
      timerEl.textContent = fmt(left);
    }
    tick();
    window._ampCartTimer = setInterval(tick, 1000);
  }

  // Probeert rustig of het element al bestaat (zonder observer)
  function bootWithRetries(maxTries = 20, delayMs = 250) {
    let tries = 0;
    const tryBoot = () => {
      const ok = document.getElementById('cart-countdown');
      if (ok) { startTimer(); return; }
      if (++tries <= maxTries) setTimeout(tryBoot, delayMs);
    };
    tryBoot();
  }

  // Hooks: bij load + wanneer de drawer opent
  if (document.readyState !== 'loading') bootWithRetries();
  else document.addEventListener('DOMContentLoaded', () => bootWithRetries());

  window.addEventListener('slidecart:open', () => bootWithRetries());
  window.addEventListener('cart-drawer:open', () => bootWithRetries());
})();
